import { connect } from 'react-redux';
import {
  getSensorAuthorizations,
  toggleModal,
  toggleSnackBar
} from 'state/callers';
import { myAccountSelector } from 'state/selectors/account';
import JiraSettings from './JiraSettings';
import withErrorBoundary from 'components/HOC/ErrorBoundryHOC';

const mapStateToProps = state => {
  const { sensorAuthorizations, configuration } = state;
  return {
    account: myAccountSelector(state),
    sensorAuthorizations,
    configuration
  };
};

const mapDispatchToProps = {
  getSensorAuthorizations,
  toggleSnackBar,
  toggleModal
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorBoundary(JiraSettings, 'Jira Settings'));
